// 品質表示まわりの projection ロジック呼び出し口をまとめます。
// 実装本体は当面 Kakousiji.js に残し、呼び出し経路だけをここへ集約します。
export function createQualityProjection(deps) {
    return {
        // BASE 項目変更を detail へ反映します。
        syncBaseFieldValueToDetail(fieldId, value) {
            return deps.syncQualityBaseFieldValueToDetail(fieldId, value);
        },
        // 品質表示 Grid を detail 保存形式へ戻します。
        syncDisplayGridToDetail(panelInfo, rows, contextOverride) {
            return deps.syncQualityDisplayGridToDetail(panelInfo, rows, contextOverride);
        }
    };
}
